import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-mono text-acid text-sm animate-pulse" data-testid="auth-loading">
          LOADING VAULT...
        </div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
